export default __webpack_public_path__ + "static/media/RecievingCall.48c9dfce.mp3";